import * as React from 'react';
import { User } from '../../../models';
import { FilterStore } from '../../../stores';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import './PVASelect.css';

interface PVASelectProps {
    options: User[];
    selected: number | undefined;
    onChange: Function;
    FilterStore?: FilterStore;
    defaultOptions?: any[];
    typeaheadTimerInSeconds?: number;
}

interface PVASelectState {
    isOpen: boolean;
    typedSoFar: string;
    typeaheadTimerHandle?: NodeJS.Timer;
    typeaheadTimerInSeconds?: number;
    typeaheadSelectedUserRow?: HTMLElement | null;
    refs: any;
}

@inject('FilterStore') @observer
export class PVASelect extends React.Component<PVASelectProps, PVASelectState> {
    constructor(props: PVASelectProps) {
        super(props);

        this.state = {
            isOpen: false,
            typedSoFar: "",
            typeaheadTimerHandle: undefined,
            typeaheadTimerInSeconds: props.typeaheadTimerInSeconds != undefined ? props.typeaheadTimerInSeconds : 0.5,
            typeaheadSelectedUserRow: null,
            refs: [],
        };
    }

    setRef = (element: any): any => {
        if (!element) return;
        const existingIndex = this.state.refs.findIndex((item:any) => item.id === element.id);
        if (existingIndex >= 0) {
            this.state.refs.splice(existingIndex, 1);
        }
        this.state.refs.push(element);
    }

    @computed get survey() {
        if (this.props.FilterStore && this.props.FilterStore.survey) {
            return this.props.FilterStore.survey;
        }
        return null;
    }

    @computed get surveyVersion() {
        if (this.props.FilterStore && this.props.FilterStore.surveyVersion) {
            return this.props.FilterStore.surveyVersion;
        }
        return null;
    }

    private selectedUser() {
        if (!this.props.selected) {
            return null;
        }
        return this.props.options.find((u: User) => {
            return u.id === this.props.selected;
        });
    }

    private userChange(id: number) {
        if (this.props.onChange) {
            this.props.onChange({
                target: {
                    value: id
                }
            });
        }
        this.setState({ isOpen: !this.state.isOpen });
    }

    private sortUsers(a: User, b: User): number {
        if (a.lastName > b.lastName) {
            return 1;
        } else if (a.lastName < b.lastName) {
            return -1;
        }
        if (a.firstName > b.firstName) {
            return 1;
        } else if (a.firstName < b.firstName) {
            return -1;
        }

        return 0;
    }

    private defaultUserRoleClass = "user-row";
    private onKeyPress = async (event: any) => {
        const updatedTypedSoFar = this.state.typedSoFar + event.key;
        await this.restartTypeaheadInterval();
        await this.setState({...this.state, typedSoFar: updatedTypedSoFar});
        if (!!this.state.typedSoFar) {
            const found = this.state.refs.find((element: HTMLElement) => {
                return element.innerText.toLowerCase().startsWith(this.state.typedSoFar.toLowerCase());
            });
            if (!!found) {
                found.scrollIntoView({behavior: "smooth", block: "nearest", inline: "nearest"});
                await this.setState({...this.state, typeaheadSelectedUserRow: found});
            }
        }
    }
    private resetTypeahead = async () => {
        await this.setState({...this.state, typedSoFar: ""});
        await this.cancelTypeahead();
    }
    private cancelTypeahead = async () => {
        if (this.state.typeaheadTimerHandle !== undefined) {
            clearInterval(this.state.typeaheadTimerHandle);
            await this.setState({...this.state, typeaheadTimerHandle: undefined});
        }
    }
    private restartTypeaheadInterval = async () => {
        await this.cancelTypeahead();
        await this.setState({...this.state, typeaheadTimerHandle:
            setInterval(this.resetTypeahead, this.state.typeaheadTimerInSeconds! * 1000)
        });
    }

    render() {

        var userSelected = this.selectedUser();

        return (
            <div className="pva-select-box" tabIndex={0} onKeyPress={this.onKeyPress}>
                <div className={`pva-select-box-selected ${this.state.isOpen ? 'open' : ''}`} onClick={(e) => this.setState({ isOpen: !this.state.isOpen })}>
                    {userSelected &&
                        <div className={this.defaultUserRoleClass}>
                            <span>{userSelected.lastName}, {userSelected.firstName}{userSelected.resultsArePrivate && <small> (Private)</small>}</span>
                        </div>
                    }
                    {!userSelected &&
                        <div className={this.defaultUserRoleClass}>
                            <span>- Select User -</span>
                        </div>
                    }
                    <div className="pva-select-box-toggle">
                        {!this.state.isOpen && <span className="glyphicon glyphicon-triangle-bottom" />}
                        {this.state.isOpen && <span className="glyphicon glyphicon-triangle-top" />}
                    </div>
                </div>
                {this.state.isOpen &&
                    <div className="pva-select-box-options">
                        {this.props.defaultOptions && this.props.defaultOptions.map((o: any, ind: number) => {
                            return <div key={`select-default-opt-${ind}`} className={this.defaultUserRoleClass} onClick={(e) => this.userChange(o.id)}>
                                <div className="user-name"><span>{o.value}</span></div>
                            </div>;
                        })}
                        {this.props.options && this.props.options.sort(this.sortUsers).map((user: User, index: number) => {
                            return <div id={`select-opt-${user.id}`} key={`select-opt-${user.id}`} ref={this.setRef} className={this.defaultUserRoleClass + (`select-opt-${user.id}` == (this.state.typeaheadSelectedUserRow == null ? "" : this.state.typeaheadSelectedUserRow.id) ? " highlighted" : "")} onClick={(e) => this.userChange(user.id)}>
                                <div className="user-name"><span>{user.lastName}, {user.firstName}</span>{user.resultsArePrivate && <small> (Private)</small>}</div>
                            </div>;
                        })}
                    </div>}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/PVASelect.tsx